import { z } from 'zod';
import { PaginationQuery } from '../../utils/listQuery';
import { paginationQuerySchema } from '../../utils/listQuery.schema';
import { listResponse } from '../../utils/listResponse';
import { labelSchema } from '../models/label.schema';

export const list = (query: PaginationQuery) => {
  return {
    endpoint: `/labels`,
    method: 'GET',
    responseSchema: listResponse(labelSchema),
    query: { ...query, includeTotal: true },
    querySchema: paginationQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
